export default "__VITE_ASSET__DNlgwHjG__"